import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'TRIX' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'TRIX', label: 'Triple EMA Oscillator', pane: 'sub', params: [12, 9], outputs: ['trix', 'maTrix'] })
